import { Route, Routes } from "react-router-dom";
import { CatalogMoldSizeProvider } from "./context/CatalogMoldSizeContext";
import { CatalogMoldSizePage } from "./pages/CatalogMoldSizePage";

type Props = {};
const CatalogMoldSize = (props: Props) => {
  return (
    <CatalogMoldSizeProvider>
      <Routes>
        <Route index element={<CatalogMoldSizePage />}></Route>
        <Route path=":moldSizeId" element={<CatalogMoldSizePage />}></Route>
      </Routes>
    </CatalogMoldSizeProvider>
  );
};
export default CatalogMoldSize;
